import { createContext, useContext } from "react";
const useSheetController = () => {
  const controller = useContext(SheetControllerContext);
  const isHidden = controller == null ? void 0 : controller.hidden;
  const isShowingNonSheet = isHidden && (controller == null ? void 0 : controller.open);
  return {
    controller,
    isHidden,
    isShowingNonSheet,
    disableDrag: controller == null ? void 0 : controller.disableDrag
  };
};
const SheetControllerContext = createContext(
  null
);
export {
  SheetControllerContext,
  useSheetController
};
//# sourceMappingURL=useSheetController.js.map
